/**
 * Centralized Google Maps Loader
 * Uses useJsApiLoader from @react-google-maps/api to ensure the API is only loaded once
 */

import { useJsApiLoader } from '@react-google-maps/api';

// Define libraries array as a static constant (must be stable reference to avoid re-loads)
const GOOGLE_MAPS_LIBRARIES = ['places'];

// API key from environment variables
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

/**
 * React hook to load and use the Google Maps API
 * Wraps useJsApiLoader to provide a single loading point for the entire app
 * @returns {Object} Object containing isLoaded and error status
 */
export const useGoogleMapsApi = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  return { isLoaded, error: loadError };
};

/**
 * Check if Google Maps is loaded
 * @returns {Boolean} True if Google Maps is loaded
 */
export const isGoogleMapsLoaded = () => {
  return window.google && window.google.maps;
};

/**
 * Get the Google Maps object
 * @returns {Object|null} Google Maps object or null if not loaded
 */
export const getGoogleMaps = () => {
  if (isGoogleMapsLoaded()) {
    return window.google.maps;
  }
  return null;
};
